import ApiService from './ApiService';

export default class BannerApi extends ApiService {
    constructor() {
        super('banner');
    }

    getBanner() {
        return this.get('');
    }

    update(payload) {
        return this.put('', payload);
    }
}
